module.exports = __webpack_public_path__ + "static/media/8OLA10.e9bea649.jpg";